import React, { useState, useEffect, useRef } from 'react';
import { Modal, Pagination, Input } from 'antd';
import { GenerateImage } from './GenerateImage';
import { initializeApollo } from '@src/apolloClient';

const client = initializeApollo();

export default function GenerateImageModal({
  isVisible,
  setIsVisible,
  userEmail,
  callback,
}) {
  const [loading, setLoading] = React.useState(false);
  return (
    <Modal
      maskClosable={!loading}
      open={isVisible}
      closable={!loading}
      onCancel={() => {
        setIsVisible(false);
      }}
      footer={null}
      centered
      destroyOnClose
      zIndex={1010}
      width={700}
    >
      <div>
        <GenerateImage
          userEmail={userEmail}
          callback={callback}
          onCloseModal={() => {
            setIsVisible(false);
          }}
          loading={loading}
          setLoading={setLoading}
        ></GenerateImage>
      </div>
    </Modal>
  );
}
